import { NgModule } from "@angular/core";
import { MaterialCommonModule } from "src/app/material-common.module";
import { InfoComponent } from "./info/info.component";
import { PurpleButtonComponent } from "./purple-button/purple-button.component";
import { CarouselComponent } from "./carousel/carousel.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { InfoCardComponent } from "./info-card/info-card.component";
import { BackButtonComponent } from "./back-button/back-button.component";
import { SessionTimerComponent } from "./session-timer/session-timer.component";

@NgModule({
    imports: [
        MaterialCommonModule,
        NgbModule
    ],
    declarations: [
        InfoComponent,
        PurpleButtonComponent,
        CarouselComponent,
        InfoCardComponent,
        BackButtonComponent,
        SessionTimerComponent
    ],
    exports: [
        InfoComponent,
        PurpleButtonComponent,
        CarouselComponent,
        InfoCardComponent,
        BackButtonComponent,
        SessionTimerComponent
    ]
})
export class CommonPartialsModule{}